import { Grid } from '@material-ui/core';
import { ModalWithButtons } from '../../components/ModalWithButtons/ModalWithButtons.component';
import SolutionCard from './SolutionCard.component';
import { useCallback, useState } from 'react';
import { LeavePrompt } from '../../components/Prompt/LeavePrompt/LeavePrompt.component';

interface SolutionCardModalProps {
  onClose: () => void;
  cardId: string;
}

export const SolutionCardModal: React.FC<SolutionCardModalProps> = ({ onClose, cardId }) => {
  const modalStyle = {
    width: '90%',
    height: '90%',
    left: '5%',
    top: '5%',
  };

  const [isEdited, setIsEdited] = useState<boolean>(false);
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState(false);

  const handleOnChange = useCallback((isDataChanged: boolean) => setIsEdited(isDataChanged), []);

  const handleCancel = () => {
    isEdited ? setIsLeavePromptOpen(true) : onClose();
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={handleCancel}
        open={true}
        title={''}
        fullScreen
        isPageInModal
        pageContainerStyle={modalStyle}
        isHideBackdrop={false}
      >
        <Grid>
          <Grid item xs={12}>
            <SolutionCard cardId={cardId} onChange={handleOnChange} />
          </Grid>
        </Grid>
      </ModalWithButtons>
      <LeavePrompt isOpen={isLeavePromptOpen} onConfirm={onClose} onCancel={() => setIsLeavePromptOpen(false)} />
    </>
  );
};
